<div class="dialog">

    <div class="video">
        <video width="100%" controls [poster]="poster" disablePictureInPicture>
            <source [src]="url" type="video/mp4">
            Your browser does not support HTML video.
        </video>
    </div>
</div>